module.exports = __webpack_public_path__ + "static/media/qianbao.aacc7f63.png";